import { render } from "./SelfAssessmentV2.vue?vue&type=template&id=1209fc83&scoped=true"
import script from "./SelfAssessmentV2.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2.vue?vue&type=style&index=0&id=1209fc83&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1209fc83"]])

export default __exports__